export default __webpack_public_path__ + "static/media/Atualizar Mobile.389486a8.svg";